export default __webpack_public_path__ + "static/media/4.2Vid.ede369f7.mp4";